import axios from "axios";
import { API_URL } from "../../const";

export const fetchSubmittedProposalsReport = (fetchData: JSON) => {
  const data = {
    SubmittedProposalsJsonToken: fetchData,
  };

  const url = `${API_URL}GetSubmittedProposalsReport`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};

/** *************** END LIST OF SUBMITTED PROPOSALS REPORT  DETAILS ***************** */

/** *************** START EXPORT SUBMITTED PROPOSALS REPORT  DETAILS ***************** */
export const ComonExportPage = (fetchData: JSON) => {
  const data = {
    CreateRequestReportToken: fetchData,
  };

  const url = `${API_URL}CreateRequestReport`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** *************** END EXPORT SUBMITTED PROPOSALS REPORT  DETAILS ***************** */
